import { ModalFooter } from "reactstrap";
import styled from "styled-components";

const StyledModalFooter = styled(ModalFooter)`
    justify-content: space-between;
`;

export { StyledModalFooter };
